import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { toast } from "react-toastify";
import * as general from '../../libs/general';
import axiosInstance from '../../axiosInstance';

const RecalculateFeeEditor = ({ data, handleSearch }) => {
  const [show, setShow] = useState(true);
  const [model, setModel] = useState({
    listIds: [],
    recalculateCustomerFee: false,
    recalculateContactFee: false,
  });

  useEffect(() => {
    initializeData(data);
  }, [data]);

  const handleModalClose = () => {
    document.querySelectorAll('.show .error-msg').forEach((item) => {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });
    document.activeElement.blur();
    setShow(false);
  };

  const initializeData = async (obj) => {
    const idsText = (obj.listIds || []).join(';');
    const urlApi = `/api/import-orders/searchTransferOrders?size=500&orderIds=${idsText}`;

    setModel({
      listIds: obj.listIds || [],
      recalculateCustomerFee: false,
      recalculateContactFee: false,
    });

    try {
      const response = await axiosInstance.get(urlApi);
      setModel((prev) => ({ ...prev, ...response.data, listIds: obj.listIds || [] }));
      setShow(true);
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  };

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    const errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    if (!model.recalculateCustomerFee && !model.recalculateContactFee) {
      toast.error("Phải chọn ít nhất 1 loại chi phí cần tính lại");
      return;
    }

    const confirmResult = await Swal.fire({
      title: "Xác nhận tính lại chi phí",
      text: "Bạn có chắc chắn muốn tính lại chi phí của đơn hàng này ? Chi phí sẽ được tính lại theo bảng giá khách hàng và đối tác đã chọn của đơn hàng",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "OK",
      cancelButtonText: "Hủy"
    });
    if (!confirmResult.isConfirmed) return;

    const dataModel = {
      listIds: model.listIds,
      recalculateCustomerFee: model.recalculateCustomerFee,
      recalculateContactFee: model.recalculateContactFee,
    };

    try {
      const response = await axiosInstance.post('/api/import-orders/recalculateOrderFees', dataModel);
      if (!response.data.success) {
        general.showFormError('.show .modal-body', response.data);
        return;
      }
      toast.success(response.data.message);
      if (response.data.warning) {
        toast.warning(response.data.warning, { autoClose: 15000 });
      }
      if (handleSearch) handleSearch();
      handleModalClose();
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Modal show={show} onHide={handleModalClose} size="xl">
      <div>
        <form className="form_validate normal-form" autoComplete="off" onSubmit={handleSubmitForm}>
          <div className="modal-content">
            <div className="modal-header position-relative flex-between">
              <div>
                <h5 className="modal-title">Tính toán lại chi phí</h5>
                {model.error && (
                  <div className="error-msg-server">{model.error}</div>
                )}
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={handleModalClose}
                aria-label="Đóng"
              ></button>
            </div>
            <div className="modal-body mt-2">
              <div className="row">
                <div className="col-md-9 mb-3">
                  <div className="group-box p-0" data-text="Danh sách đơn hàng">
                    <section className="p-1 pt-4">
                      <div className="table-responsive border table-normal table-sticky">
                        <table className="table table-striped border-normal table-bordered">
                          <thead className="table-primary head-01">
                            <tr>
                              <th width="21px" className="text-center"></th>
                              <th className="text-center">Ngày tạo</th>
                              <th className="text-center">Mã vận đơn TQ</th>
                              <th className="text-center">Mã vận đơn VN</th>
                              <th className="text-center">Mã khách hàng</th>
                              <th className="text-center">Tiền đối soát đối tác</th>
                              <th className="text-center">Tiền đối soát khách hàng</th>
                            </tr>
                          </thead>
                          {model.page && model.page.content && model.page.content.map((item, index) => (
                            <tbody className="tbody-row" key={item.id || index}>
                              <tr>
                                <td className="text-center">{index + 1}</td>
                                <td className="text-success text-center">{general.formatDate2(item.createdDate)}</td>
                                <td className="text-center">{item.cnShippingCode}</td>
                                <td className="text-center">{item.vnShippingCode}</td>
                                <td className="text-center">{item.customerCode}</td>
                                <td className="text-center">{general.formatNumber(item.contactFee)}</td>
                                <td className="text-center">{general.formatNumber(item.fee)}</td>
                              </tr>
                            </tbody>
                          ))}
                        </table>
                      </div>
                    </section>
                  </div>
                </div>
                <div className="col-md-3 mb-3">
                  <div className="group-box p-3" data-text="Tùy chọn">
                    <div className="form-check mb-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="recalculate_customer_fee"
                        checked={!!model.recalculateCustomerFee}
                        onChange={(e) => setModel({ ...model, recalculateCustomerFee: e.target.checked })}
                      />
                      <label className="form-check-label" htmlFor="recalculate_customer_fee">
                        Tính toán lại chi phí đối soát khách hàng
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="recalculate_contact_fee"
                        checked={!!model.recalculateContactFee}
                        onChange={(e) => setModel({ ...model, recalculateContactFee: e.target.checked })}
                      />
                      <label className="form-check-label" htmlFor="recalculate_contact_fee">
                        Tính toán lại chi phí đối tác
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-between">
              <div></div>
              <button type="submit" className="btn-sm btn btn-primary">Lưu</button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default RecalculateFeeEditor;
